<template>
  <dd-drawer
      @close="$emit('close')"
      v-bind="$attrs"
      title="Taken"
  >
    <paginated-tasks-component
        v-if="me && familyArray"
        :interval="interval"
        :user-id="me.id">
    </paginated-tasks-component>
  </dd-drawer>
</template>

<script>
import PaginatedTasksComponent from "./PaginatedTasksComponent.vue";
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: "TasksDrawer.vue",
  components: {
    PaginatedTasksComponent,
  },
  created() {
    this.getMe();
    this.getFamily()
  },
  data() {
    return {
      interval: 365,
    }
  },
  methods: {
    ...mapActions({
      getMe: 'getMe',
    }),
    ...mapActions(`$_customer_page`, {
      getFamily: 'getFamily',
    }),
  },
  computed: {
    createTaskRoute() {
      if (!this.customerId) return;
      return this.route('vue.task.create', {
        customer: this.customerId,
        category: this.category_id
      });
    },
    ...mapState(`$_customer_page`, {
      customerId: 'customerId',
    }),
    ...mapState({
      me: state => state.me,
      category_id: 'category_id',
    }),
    ...mapGetters(`$_customer_page`, {
      familyArray: 'familyArray',
    }),
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
